import moment from "moment";
import React from "react";

import { useLocalStorage } from "../../hooks";

import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import dropdownbottom from "../../assets/dropdownbottom.svg";
import { TwButton, TwConfirmDialog, TwContainer, TwMainLayout } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { setGlobalLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForBookings } from "../../utils/confighelpers";
import { displayAvailablePaymentMethods } from "../../utils/constants";
import ActionPopover from "./ActionPopover";


export default function BookingDetails({ navigation }) {
    const { addToast, addSuccessToast, addErrorToast } = useToast();
    const location = useLocation();
    const dispatch = useDispatch();
    const [userToken] = useLocalStorage("userToken");
    const [bookingInfo, setBookingInfo] = React.useState({});
    const [delDialogOpen, setDelDialogOpen] = React.useState(false);


    const fetchBookingsDetails = async () => {
        console.log("location.state.bookingId", location.state.bookingId);
        const config = {
            method: "get",
            url: `${getUrlForBookings()}getBookingDetails/${location.state.bookingId}`,
        };
        dispatch(setGlobalLoading(true));
        const request = await axiosInstance(config);
        dispatch(setGlobalLoading(false));
        if (request.status === 200) {
            if (request.data.statusCode === 200) {
                setBookingInfo(request.data.data)
            }
        }
    }

    React.useEffect(() => {
        fetchBookingsDetails()
    }, [])

    const calculateBoughtTickets = () => {
        let totalBookedTickets = 0;

        if (bookingInfo && bookingInfo?.ticketsBought?.length) {
            bookingInfo?.ticketsBought.forEach((item) => {
                totalBookedTickets = totalBookedTickets + parseInt(item.bookingQty)
            })
        }

        return totalBookedTickets
    }

    const calculateTotalPrice = () => {
        let totalPrice = 0;
        let serviceFees = 0;

        if (bookingInfo?.amount) {
            return parseFloat(bookingInfo?.amount || 0).toFixed(2)
        } else {
            if (bookingInfo && bookingInfo?.ticketsBought?.length) {
                bookingInfo?.ticketsBought.forEach((item) => {
                    serviceFees = serviceFees + (parseFloat(item?.serviceFee ? item?.serviceFee : 0) * parseFloat(item?.bookingQty))
                    totalPrice = totalPrice + parseFloat(item.totalPrice)
                })
            }

            // return parseFloat(totalPrice + serviceFees).toFixed(2)
            return parseFloat(totalPrice).toFixed(2)
        }
    }

    const calculateUsersReceiveTotalPrice = () => {
        let amountToUser = 0;

        if (bookingInfo && bookingInfo?.ticketsBought?.length) {
            bookingInfo?.ticketsBought.forEach((item) => {
                amountToUser = amountToUser + parseFloat(item?.amountToUser || 0)
            })
        }

        return parseFloat(parseFloat(amountToUser).toFixed(2) - calculatePaymentServiceFees()).toFixed(2)

    }

    const calculateServiceFees = () => {
        let serviceFees = 0;

        if (bookingInfo && bookingInfo?.ticketsBought?.length) {
            bookingInfo?.ticketsBought.forEach((item) => {
                serviceFees = serviceFees + (parseFloat(item?.serviceFee ? item?.serviceFee : 0) * parseFloat(item?.bookingQty))
            })
        }

        return parseFloat(serviceFees).toFixed(2)
    }

    const calculatePaymentServiceFees = () => {

        if (bookingInfo?.totalPaymentServiceFee) {
            return parseFloat(bookingInfo?.totalPaymentServiceFee).toFixed(2)
        }
        return parseFloat(0).toFixed(2)
    }

    const getPricingTypeUsed = () => {

        let pricingTypeUsed = "";

        if (bookingInfo && bookingInfo?.paymentMethod === "classPass" && bookingInfo?.passVoucherCode) {
            pricingTypeUsed = bookingInfo?.purchase_voucher_detail?.selectedPassDetail?.passName || ""
        } else if (bookingInfo && bookingInfo?.ticketsBought?.length) {
            bookingInfo?.ticketsBought.forEach((item) => {
                pricingTypeUsed = item.ticketType
            })
        }
        return pricingTypeUsed
    }

    const getAmountPaid = () => {

        let amountPaid = "";

        if (bookingInfo && bookingInfo?.paymentMethod === "classPass" && bookingInfo?.passVoucherCode) {
            amountPaid = `${calculateBoughtTickets()} Credit`
        } else if (bookingInfo && bookingInfo?.ticketsBought?.length) {
            bookingInfo?.ticketsBought.forEach((item) => {
                amountPaid = `€${parseFloat(parseFloat(item?.ticketAmount ? item?.ticketAmount : 0)).toFixed(2)} `
            })
        }

        return amountPaid
    }

    const calculatePayoutDetailPlatformFee = () => {
        let serviceFeeQty = 0;
        let serviceFeesAmount = 0;

        if (bookingInfo && bookingInfo?.ticketsBought?.length) {
            bookingInfo?.ticketsBought.forEach((item) => {
                if ((parseFloat((item?.serviceFee) ? item?.serviceFee : 0)) > 0) {
                    serviceFeeQty = serviceFeeQty + (parseFloat(item?.bookingQty))
                    serviceFeesAmount = serviceFeesAmount + (parseFloat((item?.serviceFee) ? item?.serviceFee : 0))
                }

            })
        }

        return { serviceFeeQty: parseFloat(serviceFeeQty), serviceFeesAmount: parseFloat(serviceFeesAmount).toFixed(2) }
    }

    const getStudentInfo = () => {
        let studentDetails = {}

        // if (bookingInfo && bookingInfo?.schedule_class_detail?.participants?.length) {
        //     studentDetails = bookingInfo?.schedule_class_detail?.participants.find((item) => item?.bookingId === bookingInfo.bookingId)
        // }

        if (bookingInfo) {
            studentDetails = bookingInfo?.student_detail
        }

        return studentDetails;
    }

    const handleDelete = async () => {
        setDelDialogOpen(false)
        if (bookingInfo) {

            const body = {
                bookingId: bookingInfo?.bookingId,
                scheduleClassId: bookingInfo?.scheduleClassId,
                type: "remove",
                isPackage: bookingInfo?.isPackage,
                participantId: bookingInfo?.studentId,
                familyMemberId: "",
                isRefundApplicable: true,
            };
            const config = {
                method: "post",
                url: `${getUrlForBookings()}cancelClassBooking`, // condation is not checked for event
                data: body,
            };
            dispatch(setGlobalLoading(true));
            const request = await axiosInstance(config);
            dispatch(setGlobalLoading(true));
            if (request.status === 200) {
                if (request.data.statusCode === 200) {
                    console.log(request);
                    addSuccessToast("Removed Participant");
                    await fetchBookingsDetails();
                } else {
                    console.log(request);
                    addErrorToast(request.data.message);
                }
            }
        }
    };

    const getPaymentStatus = () => {
        let paymentStatus = bookingInfo?.paymentStatus;
        // if ((bookingInfo?.paymentStatus == "Paid" || bookingInfo?.paymentStatus == "Free") && bookingInfo.paymentMethod == "NA" && parseInt(bookingInfo.amount) <= 0) {
        //     paymentStatus = 'Free';
        // }
        var displayContent = (<button
            className={
                "h-8 bg-brown-coffee rounded-lg ml-4 px-3"
            }
            onClick={() => null}
        >
            <p className={"font-bold text-sm text-white text-center"}>
                {paymentStatus}

            </p>
        </button>)
        if (bookingInfo?.status == "Cancelled" && (bookingInfo?.paymentStatus == "Unpaid" || bookingInfo?.paymentStatus == "Not-refunded") && bookingInfo.paymentMode != "Online") {
            displayContent = (<span>{displayContent}<br></br> <span className="ml-4 text-gray-600">Customer never paid for it</span></span>);
        } else if (bookingInfo?.status == "Cancelled" && bookingInfo?.paymentStatus == "Not-refunded" && bookingInfo.paymentMode == "NA" && parseInt(bookingInfo.amount) <= 0) {
            displayContent = (<span>{displayContent}<br></br> <span className="ml-4 text-gray-600">It was a free service</span></span>);
        }

        return displayContent
    };

    const getPaymentMethod = () => {
        if (bookingInfo?.paymentMethod && bookingInfo?.paymentMethod !== 'NA') {
            return Object.keys(displayAvailablePaymentMethods).indexOf(bookingInfo?.paymentMethod) >= 0 ? displayAvailablePaymentMethods[bookingInfo?.paymentMethod] : "UNKNOWN";
        } /* else if (bookingInfo?.paymentStatus == "Unpaid" && bookingInfo.paymentMethod == "NA" && bookingInfo.paymentMode != "Online" && parseInt(bookingInfo.amount) > 0) {
            return 'pay at venue';
        } else if ((bookingInfo?.paymentStatus == "Paid" || bookingInfo?.paymentStatus == "Free") && bookingInfo.paymentMethod == "NA" && parseInt(bookingInfo.amount) <= 0) {
            //return 'Free';
            return 'Not Applicable';
        } */
        return 'UNKNOWN';
    };

    // console.log("bookingInfo", bookingInfo)

    return (
        <TwMainLayout
            headTitle={`Booking Details`}
            breadcrumbs={[
                { title: location.state?.from || "Schedule Detail", onClick: () => { navigation(-1); } },
                { title: `${bookingInfo?.bookingId}` },
            ]}
            headActions={[
                (<ActionPopover
                    bookingDetails={bookingInfo}
                    handleUpdate={fetchBookingsDetails}
                />),
                (
                    <TwButton
                        className="sm:min-w-32 md:py-3.5 xl:py-3.5 md:px-6 !rounded-lg"
                        disabled={bookingInfo?.status == "Cancelled" ? true : false}
                        // disabled={bookingInfo?.status == "Cancelled" ? true : moment(bookingInfo?.eventId && bookingInfo?.event_schedule_detail ? bookingInfo?.event_schedule_detail?.classDate : bookingInfo?.schedule_class_detail?.classDate).subtract({ hours: 0 }).isBefore()}
                        // style={(bookingInfo?.status == "Cancelled" || moment(bookingInfo?.eventId && bookingInfo?.event_schedule_detail ? bookingInfo?.event_schedule_detail.classDate : bookingInfo?.schedule_class_detail.classDate).subtract({ hours: 0 }).isBefore()) ? { backgroundColor: '#D3D3D3' } : null}
                        onClick={() => setDelDialogOpen(true)}
                    >
                        Cancel Booking
                    </TwButton>
                )
            ]}
            children={
                <TwContainer className="">
                    <div className="flex flex-col gap-6 w-full">
                        <div className="flex flex-col gap-8 py-2.5 px-0 sm:px-5 lg:px-12">
                            <div className="flex">
                                <p className="text-xl sm:text-3xl font-bold">Booking ID</p>
                                <p className="text-gray-500 text-xl sm:text-3xl font-bold">: {bookingInfo?.bookingId}</p>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Booking Status</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span style={{ ...((bookingInfo?.status && bookingInfo?.status === "Cancelled") ? { color: '#FF4040' } : {}) }}>{bookingInfo?.status}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Booking Date</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{moment(bookingInfo?.createdAt || bookingInfo?.bookingDate).format('DD-MM-YYYY')}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Cancellation Date</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{bookingInfo?.status?.toLowerCase() === "cancelled" ? moment(bookingInfo?.cancellationDate).format('DD-MM-YYYY') : 'Not Applicable'}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Payment Status</p>
                                <span className="text-base">
                                    <span>:</span>
                                    {getPaymentStatus(bookingInfo)}
                                    {/* <button
                                        className={
                                            "h-8 bg-brown-coffee rounded-lg ml-4 px-3"
                                        }
                                        onClick={() => null}
                                        >
                                        <p className={"font-bold text-sm text-white text-center"}>
                                            {bookingInfo?.paymentStatus}
                                        </p>
                                    </button> */}
                                </span>
                            </div>
                        </div>
                        <div className="flex flex-col gap-8 py-2.5 px-0 sm:px-5 lg:px-12">
                            <div className="flex">
                                <p className="text-xl sm:text-3xl font-bold">Customer Details</p>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Full Name</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{getStudentInfo()?.fullName ? getStudentInfo()?.fullName : 'UNKNOWN'}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Email</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="text-indigo-bz">{getStudentInfo()?.email ? getStudentInfo()?.email : 'UNKNOWN'}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Mobile Number</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{getStudentInfo()?.username ? "" + getStudentInfo()?.username : 'UNKNOWN'}</span>
                                </span>
                            </div>
                            {/* <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">City</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{bookingInfo?.schedule_class_detail?.location?.city}</span>
                                </span>
                            </div> */}
                        </div>
                        <div className="flex flex-col gap-8 py-2.5 px-0 sm:px-5 lg:px-12">
                            <div className="flex">
                                <p className="text-xl sm:text-3xl font-bold">Purchase Details</p>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Activity Booked</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{bookingInfo?.schedule_class_detail?.className ? bookingInfo?.schedule_class_detail?.className : bookingInfo?.className}</span>
                                </span>
                            </div>
                            {/* <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Activity Status</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span style={{ ...((bookingInfo?.schedule_class_detail && bookingInfo?.schedule_class_detail?.eventStatus === "Cancelled") ? { color: '#FF4040' } : {}) }}>{bookingInfo?.schedule_class_detail?.eventStatus ? (bookingInfo?.schedule_class_detail?.eventStatus === "Cancelled" ? "This event is cancelled" : bookingInfo?.schedule_class_detail?.eventStatus) : 'UNKNOWN'}</span>
                                </span>
                            </div> */}
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Activity Date</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="text-indigo-bz">{moment(bookingInfo?.schedule_class_detail?.classDate).format('DD-MM-YYYY hh:mm A') + " - " + moment(bookingInfo?.schedule_class_detail?.classEndDate).format('hh:mm A')}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Pricing Type Used</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{getPricingTypeUsed()}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Amount Paid</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{getAmountPaid()}</span>
                                </span>
                            </div>
                            {/* {(bookingInfo?.paymentMethod === "classPass") ? (
                                <>
                                    <div className="flex">
                                        <p style={{ fontSize: '16px', lineHeight: '24px', width: '200px', paddingLeft: '20px' }}>{bookingInfo?.passVoucherCode}</p>
                                        <span className="text-base flex gap-5">
                                            <span>:</span>
                                            <span className="">{calculateBoughtTickets()}</span>
                                        </span>
                                    </div>
                                    <div className="flex">
                                        <p className="text-base min-w-36 w-36 sm:w-52">Amount Paid</p>
                                        <span className="text-base flex gap-5">
                                            <span>:</span>
                                            <span className="">{(bookingInfo?.paymentMethod === "classPass") ? `${calculateBoughtTickets()} Credit` : `€${calculateTotalPrice()} ` + (<span className="text-gray-600">Including VAT & Service Fee</span>)}</span>
                                        </span>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="flex">
                                        <p className="text-base min-w-36 w-36 sm:w-52">Tickets Bought</p>
                                        <span className="text-base flex gap-5">
                                            <span>:</span>
                                            <span className="">{calculateBoughtTickets()}</span>
                                        </span>
                                    </div>
                                    {bookingInfo?.ticketsBought?.length ? bookingInfo?.ticketsBought?.map((ticketInfo) => <div className="flex">
                                        <p style={{ fontSize: '16px', lineHeight: '24px', width: '200px', paddingLeft: '20px' }}>{ticketInfo?.ticketType}</p>
                                        <span className="text-base flex gap-5">
                                            <span>:</span>
                                            <span className="">{ticketInfo?.bookingQty} <span className="text-gray-600">X €{parseFloat(parseFloat(ticketInfo?.ticketAmount ? ticketInfo?.ticketAmount : 0)).toFixed(2)}</span></span>
                                        </span>
                                    </div>) : null}
                                </>
                            )} */}

                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Platform Service Fee</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{(bookingInfo?.paymentMethod === "classPass") ? "Not applicable" : `€${calculateServiceFees()}`}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Payment Method</p>
                                <span className="text-base flex gap-5 capitalize">
                                    <span>:</span>
                                    {/* <span className="">{bookingInfo?.paymentMethod && bookingInfo?.paymentMethod !== 'NA' ? bookingInfo?.paymentMethod : 'UNKNOWN'}</span> */}
                                    <span className=""> {getPaymentMethod()}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Payment Processing Fee</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{(bookingInfo?.paymentMethod === "classPass") ? "Not applicable" : `€${calculatePaymentServiceFees()}`}</span>
                                </span>
                            </div>
                            <div className="flex">
                                <div className="flex py-1 rounded bg-zinc-300">
                                    <p className="text-base min-w-36 w-36 sm:w-52 px-3">Total Amount Paid</p>
                                    <span className="text-base flex gap-5 pr-3">
                                        <span>:</span>
                                        <span className="">{(bookingInfo?.paymentMethod === "classPass") ? "Not applicable" : (<>{`€${calculateTotalPrice()} `} <span className="text-gray-600">Including VAT & Service Fee</span></>)}</span>
                                    </span>
                                </div>
                            </div>

                            <div className="flex">
                                <p className="text-xl sm:text-3xl font-bold">Your payout Details</p>
                            </div>

                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Amount Customer Paid</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{(bookingInfo?.paymentMethod === "classPass") ? "Not applicable" : `€${calculateTotalPrice()}`}</span>
                                </span>
                            </div>

                            <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Platform Service Fee</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    {/* <span className="text-bz-status-red">- €{calculateServiceFees() + ` (${calculateBoughtTickets()} X €${parseFloat(calculateServiceFees() / calculateBoughtTickets()).toFixed(2)})`}</span> */}
                                    {/* <span className="text-bz-status-red">- €{calculatePayoutDetailPlatformFee().serviceFeesAmount + ` (${calculatePayoutDetailPlatformFee().serviceFeeQty} X €${calculatePayoutDetailPlatformFee().serviceFeesAmount / calculatePayoutDetailPlatformFee().serviceFeeQty})`}</span> */}
                                    <span className="text-bz-status-red">- €{calculatePayoutDetailPlatformFee().serviceFeesAmount + ` (${calculatePayoutDetailPlatformFee().serviceFeeQty} X €${calculatePayoutDetailPlatformFee().serviceFeesAmount > 0 ? (calculatePayoutDetailPlatformFee().serviceFeesAmount / calculatePayoutDetailPlatformFee().serviceFeeQty) : 0})`}</span>
                                </span>
                            </div>

                            <div className="flex">
                                <div className="flex py-1 rounded bg-zinc-300">
                                    <p className="text-base min-w-36 w-36 sm:w-52 px-3">Expected Payout</p>
                                    <span className="text-base flex gap-5 pr-3">
                                        <span>:</span>
                                        <span className="">{(bookingInfo?.paymentMethod === "classPass") ? "Not applicable" : (<>€{calculateUsersReceiveTotalPrice()} <span className="text-gray-600">(Before payment processing fee charged by Payment Gateway)</span></>)} </span>
                                    </span>
                                </div>
                            </div>

                            {/* <div className="flex">
                                <p className="text-base min-w-36 w-36 sm:w-52">Your Payout</p>
                                <span className="text-base flex gap-5">
                                    <span>:</span>
                                    <span className="">{(bookingInfo?.paymentMethod === "classPass") ? "Not applicable" : `€${calculateUsersReceiveTotalPrice()} (after deducting payment proccesing fee)`} </span>
                                </span>
                            </div> */}
                        </div>

                    </div>

                    <TwConfirmDialog
                        dialogOpen={delDialogOpen}
                        dialogType="warning"
                        dialogTitle="WARNING"
                        // dialogMessage={`Cancellation will lead to full refund to the customer. Are you sure you want to cancel this booking?`}
                        dialogMessage={`Canceling this booking will issue a full refund of any money or credits used for this session. Are you sure you want to cancel this booking?`}
                        onClose={async () => {
                            setDelDialogOpen(false);
                        }}
                        onConfirm={async () => {
                            handleDelete()
                        }}
                    />
                </TwContainer>} />
    );
}
